import { useField } from 'formik';
import React, { useCallback } from 'react';
import FormSelect, { FormSelectProps } from './FormSelect';
import { SelectItem } from '@justgiving/select';

export type FormikFormSelectProps = Omit<
  FormSelectProps,
  'error' | 'touched' | 'onChange'
>;

const FormikFormSelect: React.FunctionComponent<FormikFormSelectProps> = props => {
  const [field, fieldMeta, { setValue }] = useField<string>(props.name);

  const onChange = useCallback(
    (newValue: SelectItem) => {
      setValue(newValue.value);
    },
    [setValue],
  );

  return (
    <FormSelect
      {...props}
      name={field.name}
      error={fieldMeta.error}
      touched={fieldMeta.touched}
      onChange={onChange}
    />
  );
};

export default FormikFormSelect;
